import m from "../../../../geodata/es2015/region/world/africaUltra";
window.am4geodata_region_world_africaUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/africaUltra.js
// module id = null
// module chunks = 